import {Cube, CubeCellValue, RenderContext} from '../types';

// Same visual weight as v1 (ChartConstants.LOW_BASE_OPACITY_*), duplicated to keep renderers free of v1 imports.
const OPACITY_BAR = 0.15;
const OPACITY_PIE = 0.3;

export function isLowBase(cube: Cube, cell: CubeCellValue | undefined): boolean {
    return cube.meta.lowBase?.mode === 'mark' && cell?.lowBase === true;
}

/** Point attributes for a low-base point; other modes (filter/hide) are resolved by the backend. */
export function lowBaseAttributes(kind: 'bar' | 'line' | 'pie', color: string, ctx: RenderContext): Record<string, any> {
    switch (kind) {
        case 'bar':
            return {opacity: OPACITY_BAR};
        case 'pie':
            return {opacity: OPACITY_PIE};
        default:
            return {marker: {enabled: true, fillColor: ctx.dark ? '#1E1E1E' : '#FFFFFF', lineColor: color, lineWidth: 1}};
    }
}
